import { useEffect, useState } from 'react';

const useSelect =(request) => {

    const [opciones, setOpciones] = useState([])

    useEffect(() => {
        request
            .then((resp) => {
                console.log("respuesta  <<<>>> ",resp)
                setOpciones(resp.data)
            })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return {
        opciones,
    }
}

export default useSelect